module.exports = __webpack_public_path__ + "static/media/twitter.bc54cdfe.svg";